import { FixedContainerV2, Ga4EventType, ga4Info, t } from '@slot-nx/core'
import { useVideoRecordingStore } from '@slot-nx/video-recorder'
import { TextStyle } from 'pixi.js'
import { Sprite, Text } from '@pixi/react'
import { videoRecordService } from '../domain/videoRecording'

interface ShareButtonProps {
  x: number
  y: number
  width: number
  height: number
}

export function ShareButton({ x, y, width, height }: ShareButtonProps) {
  const isSharing = useVideoRecordingStore(state => state.isSharing)
  const isShow = isSharing && !videoRecordService.isForceCleanup
  if (!isShow) return null
  return (
    <FixedContainerV2
      eventMode="static"
      cursor="pointer"
      width={width}
      height={height}
      x={x}
      y={y}
      onpointertap={() => {
        ga4Info.addEvent(Ga4EventType.record_video)
        videoRecordService.shareOrDownload()
      }}
    >
      <Sprite
        name="test"
        image="btn_saveAndShare"
        width={width}
        height={height}
        x={0}
        y={0}
      />
      <Text
        text={`${t('main_record_button')}`}
        x={190 + 32}
        y={44}
        anchor={[0.5, 0.5]}
        style={new TextStyle({
          fontFamily: 'Arial',
          fontSize: 36,
          fill: '#000000',
          fontWeight: 'bold',
          align: 'center',
        })}
      />
    </FixedContainerV2>

  )
}
